module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/TL-95b5d506f28e18497928bc5d7347ca24.png";